/* eslint-disable react-refresh/only-export-components */
import React from "react";

type props = {
  tableHead: React.ReactNode;
  tableBody?: React.ReactNode;
  children?: React.ReactNode;
  searchString?: string;
  tableRows?: number;
  rows?: number;
};

export const thTdStyle = {
  padding: "10px",
  textAlign: "left",
  borderBottom: "1px solid #ddd",
  position: "relative",
};

const ResponsiveTable = (props: props) => {
  const { tableHead, tableBody, children, searchString, tableRows, rows } =
    props;
  return (
    <div style={{ marginBottom: "15px" }} id="react-ele-table-responsive">
      <table>
        {tableHead}
        <tbody>{children || tableBody}</tbody>
      </table>
      {searchString !== "" && rows !== 0 && tableRows == 0 && (
        <p className="queries">{tableRows == 0 && "No search result found"}</p>
      )}

      {rows === 0 && <p className="queries">No data available in the table</p>}
    </div>
  );
};

export default ResponsiveTable;
